// extracted by mini-css-extract-plugin
export default {"bookings__tab":"Bookings_bookings__tab__tptOV","active":"Bookings_active__XahH0"};